import { Trans } from "@lingui/react/macro";
import { plural } from "@lingui/core/macro";
import { differenceInDays } from "date-fns";
import { startOfDay } from "date-fns";
import { startOfToday } from "date-fns";
import { humanFormat } from "@medoma/models/date-and-time";
import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import styles from "./PausedChip.module.scss";

const PausedChip = ({ pausedAt }: { pausedAt: Date }) => {
  const formattedDate = humanFormat(pausedAt, {
    dateStyle: "medium",
  });

  const startOfPaused = startOfDay(pausedAt);

  const daysElapsed = differenceInDays(startOfToday(), startOfPaused);

  const elapsedSincePaused = plural(daysElapsed, {
    0: "idag",
    one: "# dag sedan",
    other: "# dagar sedan",
  });

  return (
    <CustomProperties className={styles.paused}>
      <Chip border="solid" background="solid" shape="sharp" size="small">
        <Trans>
          Pausad {formattedDate} ({elapsedSincePaused})
        </Trans>
      </Chip>
    </CustomProperties>
  );
};

export default PausedChip;
